import { Copy06Icon } from '@/components/icons/Copy06Icon';
import { CopyCitationIcon } from '@/components/icons/CopyCitationIcon';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';

export interface CopyOptionsMenuItemsProps {
  onCopyWithCitation: () => void;
  onCopyTextOnly: () => void;
  copyWithCitationSubtext?: string;
  copyTextOnlySubtext?: string;
}

/**
 * The two copy options offered for AI answers that carry citations: copy the
 * text with the citation reference (for pasting into a Luminary editor, where
 * the reference becomes a citation chip) or copy the text only.
 */
export function CopyOptionsMenuItems({
  onCopyWithCitation,
  onCopyTextOnly,
  copyWithCitationSubtext,
  copyTextOnlySubtext,
}: CopyOptionsMenuItemsProps) {
  return (
    <>
      <MenuItem
        icon={<CopyCitationIcon size={16} />}
        label="Copy text with citations"
        subtext={copyWithCitationSubtext}
        onClick={onCopyWithCitation}
      />
      <MenuItem
        icon={<Copy06Icon size={16} />}
        label="Copy text only"
        subtext={copyTextOnlySubtext}
        onClick={onCopyTextOnly}
      />
    </>
  );
}
